// jobData.js
export const jobData = {
  "mechaniker": {
    title: "Kfz-Mechaniker (m/w/x)",
    ort: "Lübeck",
    art: "Minijob / Teilzeit / Vollzeit",
    shortDescription: "Verstärke unser Werkstatt-Team und bring dein handwerkliches Geschick ein – mit oder ohne Ausbildung.",
    aufgaben: [
      "Durchführung von Wartungs- und Reparaturarbeiten an Fahrzeugen",
      "Fehlerdiagnosen und Behebung technischer Probleme",
      "Unterstützung bei Montage- und Demontagearbeiten",
      "Allgemeine Werkstattaufgaben und Organisation",
    ],
    team: [
      "Eine abgeschlossene Ausbildung ist von Vorteil, aber keine Voraussetzung",
      "Praktische Erfahrung oder technisches Verständnis im Bereich Kfz sind sehr willkommen",
      "Zuverlässigkeit, Motivation und Lernbereitschaft",
      "Du passt gut in unser Team, wenn dir eine familiäre und freundliche Atmosphäre wichtig ist",
    ],
    benefits: [
      "Ein kollegiales Umfeld mit familiärem Teamspirit",
      "Faire und attraktive Vergütung",
      "Flexible Arbeitszeitmodelle (Mini-, Teil- oder Vollzeit)",
      "Mitarbeiterrabatte und interne Weiterentwicklungsmöglichkeiten",
    ],
  },
"aushilfe-werkstatt": {
  title: "Aushilfe Werkstatt (m/w/x)",
  ort: "Lübeck",
  art: "Minijob / Teilzeit / Vollzeit",
  shortDescription: "Unterstütze unser Werkstatt-Team bei einfachen Tätigkeiten – ohne Ausbildung, aber mit Motivation.",
  aufgaben: [
    "Unterstützung bei einfachen Werkstattarbeiten (z. B. Ölwechsel, Reifenwechsel)",
    "Allgemeine Hilfstätigkeiten in der Werkstatt",
    "Ordnung und Sauberkeit im Arbeitsbereich sicherstellen",
    "Unterstützung bei der Warenannahme und einfachen Lagerarbeiten",
  ],
  team: [
    "Keine Ausbildung erforderlich – wir bringen dir alles bei",
    "Erste Erfahrungen im Kfz-Bereich sind von Vorteil, aber keine Voraussetzung",
    "Du lernst schnell und packst gerne mit an",
    "Zuverlässigkeit, Motivation und Teamgeist",
  ],
  benefits: [
    "Attraktive und faire Vergütung",
    "Flexible Arbeitszeitmodelle (Mini-, Teil- oder Vollzeit)",
    "Ein freundliches Team mit familiärer Atmosphäre",
    "Mitarbeiterrabatte und langfristige Perspektiven",
  ],
},
"aushilfe-buero": {
  title: "Aushilfe Büro (m/w/x)",
  ort: "Lübeck",
  art: "Minijob / Teilzeit / Vollzeit",
  shortDescription: "Unterstütze unser Büro-Team im Tagesgeschäft und im Umgang mit Kunden.",
  aufgaben: [
    "Freundlicher und professioneller Umgang mit Kunden am Telefon und vor Ort",
    "Bearbeitung und Abschluss von Bestellungen",
    "Allgemeine Unterstützung bei administrativen Aufgaben",
    "Pflege von Unterlagen und einfache Büroorganisation",
  ],
  team: [
    "Du bist zuverlässig und freundlich im Umgang mit Kunden",
    "Organisationstalent und sorgfältige Arbeitsweise",
    "Erfahrung mit PC und Büroarbeit ist hilfreich, aber keine Voraussetzung",
    "Motivation und Teamfähigkeit sind uns wichtiger als perfekte Vorkenntnisse",
  ],
  benefits: [
    "Attraktive Vergütung",
    "Flexible Arbeitszeitmodelle (Mini-, Teil- oder Vollzeit)",
    "Ein kollegiales und hilfsbereites Team",
    "Sicherer Arbeitsplatz mit abwechslungsreichen Aufgaben",
  ],
}

  // weitere Jobs hier ...
};
